export default "__VITE_ASSET__Bs$lm2vV__"